import AddIncome from '../../pages/Transactions/AddIncome';
import { TransactionsController } from '../../controllers';
import { amountFormatter } from '../../utils/utils';
import { string, object, number, array } from 'yup';
import { appStore, useStores } from '../../stores';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const AddIncomeContainer = ({ closeModal, setShowSurvey }) => {
	const [openIncomeModal, setOpenIncomeModal] = useState(true);
	const [incomeSuccess, setIncomeSuccess] = useState(false);
	const [toggle, setToggle] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(
		constant.FEEDBACK.TRANSACTIONSADDINCOME
	);

	let {
		appStore: { loading },
	} = useStores();

	const getAddedIncome = () => {
		setOpenIncomeModal(false);
		setIncomeSuccess(true);
	};

	const addAnotherIncome = () => {
		setOpenIncomeModal(true);
		setIncomeSuccess(false);
	};

	const getToggle = () => {
		setToggle(!toggle);
	};

	const validationSchema = () => {
		return object({
			customer: string().optional('Select a customer'),
			orders: array(
				object({
					quantity: number().min(0.1, 'Quantity should be greater than 0.1'),
					unitPrice: number().min(1, 'Unit price should be greater than 1'),
					item: string().required('Service is required'),
				})
			),
			currencyCode: string().required('Select Currency'),
			paidDate: string().required('Enter Payment due date'),
			paymentMethod: string().required('Payment Method is required'),
			deposit: number()
				.min(1, 'Amount received should be greater than 0')
				.required('Amount Received is required')
				.test(function () {
					const { deposit, orders, discountAmount, shipping, currencyCode } =
						this.parent;
					let totalAmount = 0;
					orders.forEach(
						order => (totalAmount += order.unitPrice * order.quantity)
					);
					totalAmount =
						Math.round((totalAmount + shipping - discountAmount) * 100) / 100;

					return totalAmount < deposit
						? this.createError({
								message: `Maximum expected deposit amount should be ${amountFormatter(
									currencyCode
								).format(totalAmount)}`,
								path: 'deposit',
							})
						: true;
				}),
			salesChannel: string().required('Sales Channel is required'),
		});
	};

	const onSubmit = async values => {
		let payload = {};

		appStore.setLoading(true);
		if (!values.customer) {
			delete values.customer;
		}

		values.orders.forEach(item => {
			if (item.stock === '') {
				delete item.stock;
			}
		});

		delete values.selectFromStock;
		delete values.customerName;

		payload = {
			...values,
			paidDate: values.paidDate.toDateString(),
		};

		const { status, errorMessage } =
			await TransactionsController.postIncome(payload);
		appStore.setLoading(false);

		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			return getAddedIncome();
		}

		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<AddIncome
			closeModal={closeModal}
			openIncomeModal={openIncomeModal}
			getToggle={getToggle}
			toggle={toggle}
			loading={loading}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			incomeSuccess={incomeSuccess}
			addAnotherIncome={addAnotherIncome}
			needFeedback={needFeedback}
			setShowSurvey={setShowSurvey}
		/>
	);
};

export default observer(AddIncomeContainer);
